let logging = false;
let logging_prefix = '';

const useLogging = () => {
  return logging;
};

export const enableLog = (prefix = '') => {
  logging_prefix = prefix;
  logging = true;
}

export const log = (message, data, force) => {
  if (useLogging() || force) {
    if (data) {
      console.log(logging_prefix + message, data);
    } else {
      console.log(logging_prefix, message);
    }
  }
};

export const error = (message, data) => {
  console.error(logging_prefix + message, data);
};

export const warn = (message, data) => {
  if (useLogging()) {
    if (data) {
      console.warn(logging_prefix + message, data);
    } else {
      console.warn(logging_prefix, message);
    }
  }
};
